import {
  closestCenter,
  DndContext,
  KeyboardSensor,
  PointerSensor,
  useSensor,
  useSensors,
} from '@dnd-kit/core';
import { rectSortingStrategy, SortableContext, sortableKeyboardCoordinates } from '@dnd-kit/sortable';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import CircularProgress from '@mui/material/CircularProgress';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';

import SortableCard from './SortableCard';
import useSortableCourses from '../../hooks/useSortableCourses';

const CoursesOrder = () => {
  const {
    courses,
    hasChanges,
    isLoading,
    isSaving,
    onDragEnd,
    saveOrder,
  } = useSortableCourses();

  const sensors = useSensors(
    useSensor(PointerSensor),
    useSensor(KeyboardSensor, {
      coordinateGetter: sortableKeyboardCoordinates,
    }),
  );

  return (
    <Box p={2} position="relative" overflow="hidden">
      {isLoading ? (
        <Box alignItems="center" display="flex" justifyContent="center">
          <CircularProgress />
        </Box>
      ) : (
        <DndContext collisionDetection={closestCenter} onDragEnd={onDragEnd} sensors={sensors}>
          <SortableContext
            items={courses.map((course) => course.id)}
            strategy={rectSortingStrategy}
          >
            <Box
              alignItems="center"
              display="flex"
              justifyContent="space-between"
              mb={4}
              mt={1}
            >
              <Typography fontSize={14}>
                Para poder modificar el orden, arrastra el curso hasta el lugar deseado.
                Una vez terminadas las modificaciones, no olvides guardar los cambios.
              </Typography>
              <Button
                color="primary"
                disabled={isSaving || !hasChanges || courses.length === 0}
                onClick={saveOrder}
                variant="contained"
              >
                {isSaving ? 'Guardando...' : 'Guardar'}
              </Button>
            </Box>
            <Grid container spacing={2}>
              {!courses.length ? (
                <Grid item xs={12}>
                  <Typography variant="body1">No hay cursos disponibles</Typography>
                </Grid>
              ) : (
                courses.map((course, index) => (
                  <SortableCard key={course.id} course={course} position={index} />
                ))
              )}
            </Grid>
          </SortableContext>
        </DndContext>
      )}
    </Box>
  );
};

export default CoursesOrder;
